/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarParceiroDto,
  CriarParceiroDto,
  CriarUsuarioDoParceiroDto,
  DefinirAtivoParceiroDto,
  ErroResponse,
  PaginaDeParceirosAdminResponse,
  ParceiroAdminResponse,
  ParceirosAdminControllerEnviarCapaBody,
  ParceirosAdminControllerEnviarLogoBody,
  ParceirosAdminControllerListarParams,
  ReordenarParceirosDto,
  UsuarioDoParceiroResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getParceirosAdminControllerListarUrl = (params?: ParceirosAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/parceiros?${stringifiedParams}` : `/v1/admin/parceiros`
}

/**
 * @summary Lista os parceiros, paginado. Busca pelo nome.
 */
export const parceirosAdminControllerListar = async (params?: ParceirosAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeParceirosAdminResponse> => {

  return httpClient<PaginaDeParceirosAdminResponse>(getParceirosAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getParceirosAdminControllerListarQueryKey = (params?: ParceirosAdminControllerListarParams,) => {
    return [
    `/v1/admin/parceiros`, ...(params ? [params] : [])
    ] as const;
    }


export const getParceirosAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError = ErroResponse>(params?: ParceirosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParceirosAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof parceirosAdminControllerListar>>> = ({ signal }) => parceirosAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParceirosAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerListar>>>
export type ParceirosAdminControllerListarQueryError = ErroResponse


export function useParceirosAdminControllerListar<TData = Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  ParceirosAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof parceirosAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosAdminControllerListar<TData = Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError = ErroResponse>(
 params?: ParceirosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof parceirosAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosAdminControllerListar<TData = Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError = ErroResponse>(
 params?: ParceirosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os parceiros, paginado. Busca pelo nome.
 */

export function useParceirosAdminControllerListar<TData = Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError = ErroResponse>(
 params?: ParceirosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParceirosAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getParceirosAdminControllerCriarUrl = () => {




  return `/v1/admin/parceiros`
}

/**
 * @summary Cria o tenant PARCEIRO e o perfil comercial na mesma transação
 */
export const parceirosAdminControllerCriar = async (criarParceiroDto: CriarParceiroDto, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroAdminResponse> => {

  return httpClient<ParceiroAdminResponse>(getParceirosAdminControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarParceiroDto)
  }
);}





export const getParceirosAdminControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerCriar>>, TError,{data: CriarParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerCriar>>, TError,{data: CriarParceiroDto}, TContext> => {

const mutationKey = ['parceirosAdminControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerCriar>>, {data: CriarParceiroDto}> = (props) => {
          const {data} = props ?? {};

          return  parceirosAdminControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerCriar>>>
    export type ParceirosAdminControllerCriarMutationBody = CriarParceiroDto
    export type ParceirosAdminControllerCriarMutationError = unknown

    /**
 * @summary Cria o tenant PARCEIRO e o perfil comercial na mesma transação
 */
export const useParceirosAdminControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerCriar>>, TError,{data: CriarParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerCriar>>,
        TError,
        {data: CriarParceiroDto},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerCriarMutationOptions(options), queryClient);
    }
    export const getParceirosAdminControllerReordenarUrl = () => {




  return `/v1/admin/parceiros/ordem`
}

/**
 * @summary Reordena a vitrine inteira em uma transação. O índice na lista vira a ordem.
 */
export const parceirosAdminControllerReordenar = async (reordenarParceirosDto: ReordenarParceirosDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getParceirosAdminControllerReordenarUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reordenarParceirosDto)
  }
);}





export const getParceirosAdminControllerReordenarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerReordenar>>, TError,{data: ReordenarParceirosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerReordenar>>, TError,{data: ReordenarParceirosDto}, TContext> => {

const mutationKey = ['parceirosAdminControllerReordenar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerReordenar>>, {data: ReordenarParceirosDto}> = (props) => {
          const {data} = props ?? {};

          return  parceirosAdminControllerReordenar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerReordenarMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerReordenar>>>
    export type ParceirosAdminControllerReordenarMutationBody = ReordenarParceirosDto
    export type ParceirosAdminControllerReordenarMutationError = ErroResponse

    /**
 * @summary Reordena a vitrine inteira em uma transação. O índice na lista vira a ordem.
 */
export const useParceirosAdminControllerReordenar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerReordenar>>, TError,{data: ReordenarParceirosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerReordenar>>,
        TError,
        {data: ReordenarParceirosDto},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerReordenarMutationOptions(options), queryClient);
    }
    export const getParceirosAdminControllerObterUrl = (id: string,) => {




  return `/v1/admin/parceiros/${id}`
}

/**
 * @summary Detalha um parceiro
 */
export const parceirosAdminControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroAdminResponse> => {

  return httpClient<ParceiroAdminResponse>(getParceirosAdminControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getParceirosAdminControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/parceiros/${id}`
    ] as const;
    }


export const getParceirosAdminControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParceirosAdminControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof parceirosAdminControllerObter>>> = ({ signal }) => parceirosAdminControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParceirosAdminControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerObter>>>
export type ParceirosAdminControllerObterQueryError = ErroResponse


export function useParceirosAdminControllerObter<TData = Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof parceirosAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosAdminControllerObter<TData = Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof parceirosAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosAdminControllerObter<TData = Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um parceiro
 */

export function useParceirosAdminControllerObter<TData = Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParceirosAdminControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getParceirosAdminControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/parceiros/${id}`
}

/**
 * @summary Edita o perfil comercial. O `slug` não muda.
 */
export const parceirosAdminControllerAtualizar = async (id: string,
    atualizarParceiroDto: AtualizarParceiroDto, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroAdminResponse> => {

  return httpClient<ParceiroAdminResponse>(getParceirosAdminControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarParceiroDto)
  }
);}





export const getParceirosAdminControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerAtualizar>>, TError,{id: string;data: AtualizarParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerAtualizar>>, TError,{id: string;data: AtualizarParceiroDto}, TContext> => {

const mutationKey = ['parceirosAdminControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerAtualizar>>, {id: string;data: AtualizarParceiroDto}> = (props) => {
          const {id,data} = props ?? {};

          return  parceirosAdminControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerAtualizar>>>
    export type ParceirosAdminControllerAtualizarMutationBody = AtualizarParceiroDto
    export type ParceirosAdminControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita o perfil comercial. O `slug` não muda.
 */
export const useParceirosAdminControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerAtualizar>>, TError,{id: string;data: AtualizarParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarParceiroDto},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getParceirosAdminControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/parceiros/${id}/ativo`
}

/**
 * @summary Tira ou devolve o parceiro à vitrine. NÃO desativa o ambiente dele.
 */
export const parceirosAdminControllerDefinirAtivo = async (id: string,
    definirAtivoParceiroDto: DefinirAtivoParceiroDto, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroAdminResponse> => {

  return httpClient<ParceiroAdminResponse>(getParceirosAdminControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoParceiroDto)
  }
);}





export const getParceirosAdminControllerDefinirAtivoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoParceiroDto}, TContext> => {

const mutationKey = ['parceirosAdminControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerDefinirAtivo>>, {id: string;data: DefinirAtivoParceiroDto}> = (props) => {
          const {id,data} = props ?? {};

          return  parceirosAdminControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerDefinirAtivo>>>
    export type ParceirosAdminControllerDefinirAtivoMutationBody = DefinirAtivoParceiroDto
    export type ParceirosAdminControllerDefinirAtivoMutationError = unknown

    /**
 * @summary Tira ou devolve o parceiro à vitrine. NÃO desativa o ambiente dele.
 */
export const useParceirosAdminControllerDefinirAtivo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoParceiroDto},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerDefinirAtivoMutationOptions(options), queryClient);
    }
    export const getParceirosAdminControllerEnviarLogoUrl = (id: string,) => {




  return `/v1/admin/parceiros/${id}/logo`
}

/**
 * @summary Envia o logo. Exige proporção 3:1 (ex.: 1200×400).
 */
export const parceirosAdminControllerEnviarLogo = async (id: string,
    parceirosAdminControllerEnviarLogoBody: ParceirosAdminControllerEnviarLogoBody, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroAdminResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, parceirosAdminControllerEnviarLogoBody.arquivo);

  return httpClient<ParceiroAdminResponse>(getParceirosAdminControllerEnviarLogoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getParceirosAdminControllerEnviarLogoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerEnviarLogo>>, TError,{id: string;data: ParceirosAdminControllerEnviarLogoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerEnviarLogo>>, TError,{id: string;data: ParceirosAdminControllerEnviarLogoBody}, TContext> => {

const mutationKey = ['parceirosAdminControllerEnviarLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerEnviarLogo>>, {id: string;data: ParceirosAdminControllerEnviarLogoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  parceirosAdminControllerEnviarLogo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerEnviarLogoMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerEnviarLogo>>>
    export type ParceirosAdminControllerEnviarLogoMutationBody = ParceirosAdminControllerEnviarLogoBody
    export type ParceirosAdminControllerEnviarLogoMutationError = ErroResponse

    /**
 * @summary Envia o logo. Exige proporção 3:1 (ex.: 1200×400).
 */
export const useParceirosAdminControllerEnviarLogo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerEnviarLogo>>, TError,{id: string;data: ParceirosAdminControllerEnviarLogoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerEnviarLogo>>,
        TError,
        {id: string;data: ParceirosAdminControllerEnviarLogoBody},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerEnviarLogoMutationOptions(options), queryClient);
    }
    export const getParceirosAdminControllerEnviarCapaUrl = (id: string,) => {




  return `/v1/admin/parceiros/${id}/capa`
}

/**
 * @summary Envia a capa do card da vitrine. Proporção livre.
 */
export const parceirosAdminControllerEnviarCapa = async (id: string,
    parceirosAdminControllerEnviarCapaBody: ParceirosAdminControllerEnviarCapaBody, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroAdminResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, parceirosAdminControllerEnviarCapaBody.arquivo);

  return httpClient<ParceiroAdminResponse>(getParceirosAdminControllerEnviarCapaUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getParceirosAdminControllerEnviarCapaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerEnviarCapa>>, TError,{id: string;data: ParceirosAdminControllerEnviarCapaBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerEnviarCapa>>, TError,{id: string;data: ParceirosAdminControllerEnviarCapaBody}, TContext> => {

const mutationKey = ['parceirosAdminControllerEnviarCapa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerEnviarCapa>>, {id: string;data: ParceirosAdminControllerEnviarCapaBody}> = (props) => {
          const {id,data} = props ?? {};

          return  parceirosAdminControllerEnviarCapa(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerEnviarCapaMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerEnviarCapa>>>
    export type ParceirosAdminControllerEnviarCapaMutationBody = ParceirosAdminControllerEnviarCapaBody
    export type ParceirosAdminControllerEnviarCapaMutationError = unknown

    /**
 * @summary Envia a capa do card da vitrine. Proporção livre.
 */
export const useParceirosAdminControllerEnviarCapa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerEnviarCapa>>, TError,{id: string;data: ParceirosAdminControllerEnviarCapaBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerEnviarCapa>>,
        TError,
        {id: string;data: ParceirosAdminControllerEnviarCapaBody},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerEnviarCapaMutationOptions(options), queryClient);
    }
    export const getParceirosAdminControllerCriarUsuarioUrl = (id: string,) => {




  return `/v1/admin/parceiros/${id}/usuario`
}

/**
 * @summary Cria o usuário do parceiro no ambiente dele, sempre com o cargo `parceiro`
 */
export const parceirosAdminControllerCriarUsuario = async (id: string,
    criarUsuarioDoParceiroDto: CriarUsuarioDoParceiroDto, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioDoParceiroResponse> => {

  return httpClient<UsuarioDoParceiroResponse>(getParceirosAdminControllerCriarUsuarioUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarUsuarioDoParceiroDto)
  }
);}





export const getParceirosAdminControllerCriarUsuarioMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerCriarUsuario>>, TError,{id: string;data: CriarUsuarioDoParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerCriarUsuario>>, TError,{id: string;data: CriarUsuarioDoParceiroDto}, TContext> => {

const mutationKey = ['parceirosAdminControllerCriarUsuario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosAdminControllerCriarUsuario>>, {id: string;data: CriarUsuarioDoParceiroDto}> = (props) => {
          const {id,data} = props ?? {};

          return  parceirosAdminControllerCriarUsuario(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosAdminControllerCriarUsuarioMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosAdminControllerCriarUsuario>>>
    export type ParceirosAdminControllerCriarUsuarioMutationBody = CriarUsuarioDoParceiroDto
    export type ParceirosAdminControllerCriarUsuarioMutationError = ErroResponse

    /**
 * @summary Cria o usuário do parceiro no ambiente dele, sempre com o cargo `parceiro`
 */
export const useParceirosAdminControllerCriarUsuario = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosAdminControllerCriarUsuario>>, TError,{id: string;data: CriarUsuarioDoParceiroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosAdminControllerCriarUsuario>>,
        TError,
        {id: string;data: CriarUsuarioDoParceiroDto},
        TContext
      > => {
      return useMutation(getParceirosAdminControllerCriarUsuarioMutationOptions(options), queryClient);
    }
